export default __webpack_public_path__ + "static/media/spinner.dbc35ca1.gif";